import type { AxiosInstance } from 'axios'
import type { MeasurementBody, MeasurementType, MeasurementTypeType } from 'src/types/measurements'
import { castTrainingParams, type TrainingDiariesParams } from 'src/types/api'
import { parseDate } from 'src/utils/datetime'


export class MeasurementsApi {
  api: AxiosInstance

  urls = {
    measurementTypes: () => 'measurement-types/' as const,
    measurements: () => 'measurements/' as const,
    measurement: (id: MeasurementType['id']) => `measurements/${id}/`,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  getMeasurementTypes = async (): Promise<MeasurementTypeType[]> => {
    const response = await this.api.get<MeasurementTypeType[]>(this.urls.measurementTypes())
    return response.data
  }

  getMeasurements = async (params: TrainingDiariesParams): Promise<MeasurementType[]> => {
    const response = await this.api.get<MeasurementType[]>(
      this.urls.measurements(),
      { params: castTrainingParams(params) }
    )
    return response.data.map(row => ({...row, datetime: parseDate(row.datetime)}))
  }

  getMeasurement = async (id: MeasurementType['id']): Promise<MeasurementType> => {
    const response = await this.api.get<MeasurementType>(this.urls.measurement(id))
    return { ...response.data, datetime: parseDate(response.data.datetime) }
  }

  postMeasurement = async (measureBody: MeasurementBody): Promise<MeasurementType> => {
    const response = await this.api.post<MeasurementType>(this.urls.measurements(), measureBody)
    const result = {...response.data}
    result.datetime = parseDate(response.data.datetime)
    return result
  }

  editMeasurement = async (id: MeasurementType['id'], measureBody: MeasurementBody): Promise<MeasurementType> => {
    await this.api.delete<MeasurementType>(this.urls.measurement(id))
    return await this.postMeasurement(measureBody)
  }
}
